import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  getDepositBonusAvailability,
  getDepositBonusList,
  getDepositBonusAmount,
  clearDepositBonusAmount,
} from './actions';
import {
  depositBonusFeature,
} from './feature';

@Injectable({
  providedIn: 'root',
})
export class DepositBonusFacade {
  private _store = inject(Store);

  public depositBonusAvailability$ = this._store.select(depositBonusFeature.selectDepositBonusAvailability);
  public depositBonusList$ = this._store.select(depositBonusFeature.selectDepositBonusList);
  public depositBonusAmount$ = this._store.select(depositBonusFeature.selectDepositBonusAmount);
  public isDepositBonusLoading$ = this._store.select(depositBonusFeature.selectIsPending);

  public getDepositBonusAvailability(accountId: number, lang: string): void {
    this._store.dispatch(getDepositBonusAvailability(accountId, lang));
  }

  public getDepositBonusList(accountId: number): void {
    this._store.dispatch(getDepositBonusList(accountId));
  }

  public getDepositBonusAmount(accountId: number, depositAmount: number, wasReceived: boolean): void {
    this._store.dispatch(getDepositBonusAmount(accountId, depositAmount, wasReceived));
  }

  public clearDepositBonusAmount(): void {
    this._store.dispatch(clearDepositBonusAmount());
  }
}
